import Setting from "./Setting";
import AllowedValue from "./AllowedValue";

const validateBooleanValue = (val) => {
  if (typeof val === "string") {
    return val !== "false";
  }
  return !!val;
};

const PREF_DEFINITIONS = [
  {
    id: "powerGraphExpandedByDefault",
    name: "Expand power charts by default",
    type: "select",
    mutatorCallback: validateBooleanValue,
    allowedValues: [
      new AllowedValue("No", false),
      new AllowedValue("Yes", true),
    ],
  },
  {
    id: "potentialGraphExpandedByDefault",
    name: "Expand potential charts by default",
    type: "select",
    mutatorCallback: validateBooleanValue,
    allowedValues: [
      new AllowedValue("No", false),
      new AllowedValue("Yes", true),
    ],
  },
];

const getPreferences = (removePrefs = []) =>
  PREF_DEFINITIONS.filter((pref) => !removePrefs.includes(pref.id)).map(
    (pref) =>
      new Setting(
        pref.id,
        pref.name,
        pref.type,
        pref.mutatorCallback,
        pref.allowedValues,
      ),
  );

export default getPreferences;
